function useCategoryAggs() {
  const getCategoryAggs = (category) => {
    const filterAggs = (agg) => agg.buckets;
    return [
      ...category.aggs?.filter(filterAggs) ?? [],
      ...category.features?.filter(filterAggs) ?? []
    ];
  };
  return {
    getCategoryAggs
  };
}
;
export {
  useCategoryAggs as default
};
